// @flow
import React from 'react'
import { connect } from 'react-redux'
import { Template } from './Template'
import { withRouter } from 'lib/hooks/withRouter'

type Props = {
  dispatch: Function,
  location: Object,
}

class AccountStatementsView extends React.Component {
  props: Props

  constructor(props) {
    super(props)
    this.state = {
      statements: [],
    }
  }

  fetchDataFromLocalStorage(id) {
    const json = localStorage.getItem(id)
    const statements = JSON.parse(json)
    this.setState({ statements: statements })
  }

  componentDidMount() {
    const queryParams = this.props.location.query
    const id = queryParams.get('id')
    document.title = `Batch ${id}`
    this.fetchDataFromLocalStorage(id)
  }

  render() {
    return <Template statements={this.state.statements} />
  }
}

export default withRouter(connect()(AccountStatementsView))
